import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IcInstagramAndroid } from '../icons/IcInstagramAndroid';

/** Copy and links aligned with `activity_contact_us.xml` + `ContactUsActivity.kt` (TipPay Emp). */
const INTRO_TEXT =
  'You can get in touch with us through below platforms. Our Team will reach out to you as soon as it would be possible';

const PHONE_DISPLAY = '+91 7736820598';
const PHONE_TEL = '+917736820598';
const EMAIL = 'info@tippay.co.in';

const LINKEDIN_URL = 'https://www.linkedin.com/company/tippaybypayversetechnologies/';
const INSTAGRAM_URL = 'https://www.instagram.com/tippaybypayverse/';
const WHATSAPP_URL = 'https://wa.me/917736820598';

const OFFICE_COMPANY = 'Payverse Technologies Pvt Ltd';
const OFFICE_ADDRESS = `17/1, Stark Towers, Kamarajar Nagar,
Kalapatti, Coimbatore – 641 014
Tamil Nadu, India`;

function CallInIcon() {
  return (
    <svg className="contact-us-row-icon" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg className="contact-us-row-icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      />
    </svg>
  );
}

function LinkedInIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#fff"
        d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
      />
    </svg>
  );
}

function WhatsAppIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#fff"
        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
      />
    </svg>
  );
}

function ContactUsPage() {
  const navigate = useNavigate();

  return (
    <div className="contact-us-page">
      <header className="contact-us-topbar">
        <button
          type="button"
          className="contact-us-back"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
          </svg>
        </button>
        <h1 className="contact-us-topbar-title">Contact Us</h1>
        <span className="contact-us-topbar-spacer" aria-hidden="true" />
      </header>

      <div className="contact-us-body">
        <p className="contact-us-intro">{INTRO_TEXT}</p>

        <section className="contact-us-card" aria-labelledby="contact-support-heading">
          <h2 id="contact-support-heading" className="contact-us-card-title">
            Customer Support
          </h2>
          <a href={`tel:${PHONE_TEL}`} className="contact-us-row">
            <span className="contact-us-row-icon-wrap" aria-hidden="true">
              <CallInIcon />
            </span>
            <span className="contact-us-row-text">
              <span className="contact-us-row-label">Contact Number</span>
              <span className="contact-us-row-value contact-us-row-value--link">{PHONE_DISPLAY}</span>
            </span>
          </a>
          <a href={`mailto:${EMAIL}`} className="contact-us-row">
            <span className="contact-us-row-icon-wrap" aria-hidden="true">
              <MailIcon />
            </span>
            <span className="contact-us-row-text">
              <span className="contact-us-row-label">Email ID</span>
              <span className="contact-us-row-value contact-us-row-value--link">{EMAIL}</span>
            </span>
          </a>
        </section>

        <section className="contact-us-card" aria-labelledby="contact-office-heading">
          <h2 id="contact-office-heading" className="contact-us-card-title">
            Office Details
          </h2>
          <p className="contact-us-office-company">{OFFICE_COMPANY}</p>
          <p className="contact-us-office-address">{OFFICE_ADDRESS}</p>
        </section>

        <section className="contact-us-card contact-us-card--social" aria-labelledby="contact-social-heading">
          <h2 id="contact-social-heading" className="contact-us-card-title">
            Social Media
          </h2>
          <div className="contact-us-social-row">
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-us-social-btn contact-us-social-btn--linkedin"
              aria-label="TipPay on LinkedIn"
            >
              <LinkedInIcon />
            </a>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-us-social-btn contact-us-social-btn--instagram"
              aria-label="TipPay on Instagram"
            >
              <IcInstagramAndroid className="contact-us-instagram-svg" width={44} height={44} />
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-us-social-btn contact-us-social-btn--whatsapp"
              aria-label="Contact on WhatsApp"
            >
              <WhatsAppIcon />
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default ContactUsPage;
